import { Fragment } from 'react';

import { flexRender } from '@tanstack/react-table';
import classnames from 'classnames';

import { ITableRowProps } from 'types/components/table/components/body';

function TableRow<TData>({ onCollapsed, onExpanded, onRowSelected, renderSubComponent, row }: ITableRowProps<TData>) {
  const { getIsExpanded, getToggleExpandedHandler, getVisibleCells, id: rowId, original } = row;

  return (
    <Fragment>
      <tr
        onClick={(e) => {
          const toggle = getToggleExpandedHandler();

          e.preventDefault();

          if (!getIsExpanded()) {
            onExpanded?.(original);
          } else {
            onCollapsed?.();
          }

          toggle();
          onRowSelected?.(original);
        }}>
        {getVisibleCells().map((cell) => {
          const {
            column: { columnDef, getSize },
            getContext,
            id: cellId,
          } = cell;
          const expandedCellId = `${rowId}_table-expander-cell`;
          const size = getSize();

          return (
            <td
              className={classnames({
                'table-expanded-cell': cellId === expandedCellId,
              })}
              key={cellId}
              onClick={(e) => {
                if (cellId !== expandedCellId) {
                  return;
                }

                e.stopPropagation();

                const toggle = getToggleExpandedHandler();

                if (!getIsExpanded()) {
                  onExpanded?.(original);
                } else {
                  onCollapsed?.();
                }

                toggle();
              }}
              style={{
                maxWidth: size !== 150 ? size : undefined,
                width: size !== 150 ? size : undefined,
              }}>
              {flexRender(columnDef.cell, getContext())}
            </td>
          );
        })}
      </tr>
      {getIsExpanded() && (
        <tr className="table-expanded-row">
          <td>&nbsp;</td>
          <td colSpan={getVisibleCells().length - 1}>{renderSubComponent?.({ row })}</td>
        </tr>
      )}
    </Fragment>
  );
}

export default TableRow;
